import allStoresSingleton, {loadStores} from "../../components/stores/StoreLoader";
import {ExecutionEnvironment, isServerComponent} from '../../components/stores/InterfaceStore';
import {use} from "react";
import {StoreContext} from "./StoreContext";

export function useStores() {
    if (ExecutionEnvironment.canUseDOM) {
        // we don't want to create a new set of stores every time we call this function, and we can't use the singleton
        // on the server because the singleton is global across all instances of the server/all requests
        return allStoresSingleton;
    } else if (isServerComponent) {
        // If inside a server component, we want to return the cached response of loadStores()
        return loadStores();
    } else {
        // We are inside a client component on the server, we can use context as long as we're not at the top level
        return use(StoreContext);
    }
}